module.exports = __webpack_public_path__ + "img/CF_2AA.1.4c008dd4.jpg";